module.exports = __webpack_public_path__ + "assets/barcode.ceceffe1.svg";